export default "__VITE_ASSET__C$g_l1s2__"